





















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class EditFieldInArray extends Vue {
  @Prop() entity!: string;
  @Prop() index!: number;
  showEdit: boolean = false;
  mask!: any;
  data() {
    return {
      mask: undefined
    };
  }

  check() {
    let entObj = {
      body: this.entity,
      index: this.index
    };
    this.$emit("save", entObj);
    this.showEdit = false;
  }

  deleteItem() {
    this.$emit("deleteItem", this.index);
  }

  mounted() {
    this.mask = [
      "+7 ",
      "(",
      /\d/,
      /\d/,
      /\d/,
      ") ",
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/
    ];
  }
}
